import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.sass']
})
export class HelpPageComponent implements OnInit {

  constructor() {  console.log("HelpPageComponent");}

  ngOnInit() {
    console.log("HelpPageComponent");
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/help/components/help-page/help-page.component.ts